module.exports = __webpack_public_path__ + "static/media/square-distilery.f85dee8d.jpg";